import React from 'react'
import { decorationMobx, eatTypeStatusMobx } from '@mobxStore'
import { showMsg } from '@utils'
import './style.scss'

export interface IEatTypeSwitcherProps {
  types: TEatType[];
  value: TEatType;
  onChange: (value: TEatType) => void;
}

const EatTypeSwitcher: React.FC<IEatTypeSwitcherProps> = (props) => {
  const { eatTypeEntriesMap } = decorationMobx
  const { types, value, onChange } = props

  const handleSwitch = (val: string) => {
    if (eatTypeStatusMobx.disableSwitchEatType) {
      showMsg(i18n.t('menu.disableSwitchEatType'))
      return
    }
    if (val !== value) {
      onChange && onChange(val as TEatType)
    }
  }

  return (
    <div className='eat-type-swicher'>
      {types.map((item) => (
        <span key={item} className={`eat-type-item${value === item ? ' active' : ''}`} onClick={() => handleSwitch(item)}>{eatTypeEntriesMap[item]?.name || i18n.t(`entry.${item}`)}</span>
      ))}
    </div>
  )
}

export default EatTypeSwitcher
